<template>
  <AppDatepicker
    :modelValue="modelValue"
    :disabled="disabled"
    :disabledDates="{ predicate: disabledDates }"
    class="kamil-datepicker"
    @update:modelValue="onUpdate"
  />
</template>

<script>
import AppDatepicker from 'vue3-datepicker'
// import moment from 'moment'

export default {
  name: 'BaseDatepicker',
  components: {
    AppDatepicker
  },
  props: {
    modelValue: {},
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDates: {
      type: Function
    }
  },
  emits: [
    'update:modelValue'
  ],
  methods: {
    onUpdate (event) {
      this.$emit('update:modelValue', event)
    }
  }
}
</script>

<style lang="scss">
.kamil-datepicker {
  height: 42px;
  background: #242428;
  outline: none;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  text-align: center;
}
</style>
